import { ReactElement } from "react";
import BackButton from "../Buttons/BackButton/BackButton";

export interface DefaultHeadingProps {
  heading: string;
  showDefaultBackButton?: boolean;
  children?: ReactElement;
  customFontSize?: string;
  customFontColor?: string;
  disclaimerText?: string;
  disclaimerColor?: string;
  primaryPlaceNewOrderText?:boolean;
  createSecondaryOrderHeading?: boolean;
}

const DefaultHeading = (props: DefaultHeadingProps) => {
  if (props?.primaryPlaceNewOrderText) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          paddingTop: "16px",
          paddingBottom: "4px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexGrow: 1,
          }}
        >
          <div
            style={{
              textAlign: "left",
              fontWeight: 600,
              width: "fit-content",
              fontSize: "1.1rem",
              display: "flex",
            }}
          >

            <div style={{display: "inline-flex", width: "5px", height: "30px", backgroundColor: "var(--dashboard-theme-color)", borderRadius: "9999px", marginRight: "8px"}} />
            {props.heading}

            <span
              style={{
                fontSize: props.customFontSize,
                color: props.customFontColor,
              }}
            ></span>
            {props.disclaimerText && (
              <span
                style={{
                  color: props.disclaimerColor,
                  fontSize: "12.5px",
                  fontWeight: 400,
                  marginLeft: "1rem",
                }}
              >
                *{props.disclaimerText}
              </span>
            )}
          </div>
          {props.children}
        </div>
      </div>
    );
  }

  if (props?.createSecondaryOrderHeading) {
     return (
        <div className="default-header-container">
          <div className="default-header-label" style={{ display: "flex", border: "none", padding: 0 }}>
            <div className="default_header_label_bar" />
            <span
              style={{
                fontSize: props.customFontSize,
                color: props.customFontColor,
              }}
            >
              {props.heading}
            </span>
            {props.disclaimerText && (
              <span
                style={{
                  color: props.disclaimerColor,
                  fontSize: "12.5px",
                fontWeight: 400,
                marginLeft: "1rem",
              }}
            >
              *{props.disclaimerText}
            </span>
          )}
        </div>
        <div className="heading-buttons">
          {props.children}
          {props.showDefaultBackButton && <BackButton />}
        </div>
      </div>
    );
  }

  return (
    <div className="default-header-container">
      <div className="default-header-label" style={{ display: "flex" }}>
        <span
          style={{
            fontSize: props.customFontSize,
            color: props.customFontColor,
          }}
        >
          {props.heading}
        </span>
        {props.disclaimerText && (
          <span
            style={{
              color: props.disclaimerColor,
              fontSize: "12.5px",
              fontWeight: 400,
              marginLeft: "1rem",
            }}
          >
            *{props.disclaimerText}
          </span>
        )}
      </div>
      <div className="heading-buttons">
        {props.children}
        {props.showDefaultBackButton && <BackButton />}
      </div>
    </div>
  );
};

export default DefaultHeading;
